<template>
  <div class="sa-list-component">
    <div class="sa-list-component-header"></div>
    <div class="sa-list-component-body">
      <magazzino-articoli-storico-giacenze-component :visibleColumns="visibleColumnArray" ref="cmpMagazzinoArticoliStoricoGiacenzeComponent"> </magazzino-articoli-storico-giacenze-component>
    </div>
  </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoArticoliStoricoGiacenzeComponent from "./MagazzinoArticoliStoricoGiacenzeComponent.vue";

export default {
  name: "MagazzinoArticoliTabStoricoContabileComponent",
  mixins: [UtilityMixin],
  props: {},
  components: { MagazzinoArticoliStoricoGiacenzeComponent },
  mounted() {
    this.id = this.$route.params.id;
    let filtro = {
      idMagazzino: this.$route.params.id,
    };
    this.$refs.cmpMagazzinoArticoliStoricoGiacenzeComponent.init(filtro);
  },
  created() {
    //this.$refs.cmpMagazzinoArticoliStoricoGiacenzeComponent.init({ idMagazzino: this.$route.params.id });
  },
  data() {
    return {
      show: false,
      currentPage: 1,
      visibleColumnArray: ["documento", "articolo", "prezzoUnitario", "quantita", "causaleDocumentoOperazioneMagazzino", "actions"],
      perPage: 10,
      rows: 0,
      id: null,
      jsonData: {},
      magazziniItems: [],
      pathResouce: "/magazzinomagazzini",
    };
  },
  methods: {
    init(filtro) {
      let me = this;
      me.$refs.cmpMagazzinoArticoliStoricoGiacenzeComponent.init(filtro);
    },
  },
};
</script>
